import {
  ContractorPortalLogout,
  ContractorPortalSetAuthToken,
  ContractorPortalSignInPhone,
  ContractorPortalSetValidateLockedUntil,
  ContractorPortalUpdatePhone,
  ContractorPortalUpdateEmail,
  ContractorPortalSendCode,
  ContractorPortalUpdatePhoneSendCode,
  ContractorPortalUpdateEmailSendCode,
} from 'src/constants/actionTypes'
import { authService } from 'src/services/AuthService'
import { Action } from 'src/utils/reduxUtils'
import { ContractorPortalAuthState } from './types'

const getInitialState = (): ContractorPortalAuthState => ({
  contractorPortalAuthToken: authService.getStoredContractorPortalAuthToken(),

  resendAvailableAt: null,
  resendRemainingCount: null,
  validateLockedUntil: null,
  attemptsRemaining: null,
})

export const contractorPortalAuthReducer = (
  state: ContractorPortalAuthState = getInitialState(),
  action: Action<any>,
): ContractorPortalAuthState => {
  switch (action.type) {
    case ContractorPortalSetAuthToken.type.SUCCESS:
      return {
        ...state,
        contractorPortalAuthToken: action.payload,

        resendAvailableAt: null,
        resendRemainingCount: null,
        validateLockedUntil: null,
        attemptsRemaining: null,
      }
    case ContractorPortalSignInPhone.type.SUCCESS:
    case ContractorPortalSendCode.type.SUCCESS:
    case ContractorPortalUpdatePhoneSendCode.type.SUCCESS:
    case ContractorPortalUpdateEmailSendCode.type.SUCCESS:
      return {
        ...state,
        resendAvailableAt: action.payload.resendAvailableAt,
        resendRemainingCount: action.payload.resendRemainingCount,
        validateLockedUntil: action.payload.validateLockedUntil,
        attemptsRemaining: action.payload.attemptsRemaining,
      }

    case ContractorPortalSetValidateLockedUntil.type.SUCCESS:
      return {
        ...state,
        validateLockedUntil: action.payload,
      }
    case ContractorPortalUpdatePhone.type.SUCCESS:
    case ContractorPortalUpdateEmail.type.SUCCESS:
      return {
        ...state,
        resendAvailableAt: null,
        resendRemainingCount: null,
        validateLockedUntil: null,
        attemptsRemaining: null,
      }
    case ContractorPortalLogout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
